import { render } from "./ArticlesGrid.vue?vue&type=template&id=3795905a&scoped=true"
import script from "./ArticlesGrid.vue?vue&type=script&lang=js"
export * from "./ArticlesGrid.vue?vue&type=script&lang=js"

import "./ArticlesGrid.vue?vue&type=style&index=0&id=3795905a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3795905a"

export default script